/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Separate_Dates_OnInputs */

const fr_label_separate_dates_on = /** @type {(inputs: Label_Separate_Dates_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activé`)
};

const en_label_separate_dates_on = /** @type {(inputs: Label_Separate_Dates_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Label_Separate_Dates_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_separate_dates_on = /** @type {((inputs?: Label_Separate_Dates_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Separate_Dates_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_separate_dates_on(inputs)
	return en_label_separate_dates_on(inputs)
});